import { useLocation, useNavigate } from 'react-router-dom'
import { getLocale, stripLocale, localePath } from '../i18n'

// Selector de PIAȚĂ (nu limbă): US (engleză, root) + CH (germană, /de). RO e parcat —
// rutele /ro rămân vii, dar nu apar aici (ca să nu pară că vindem în RO).
// Steaguri SVG (nu emoji — emoji se randează inconsistent pe Windows).

function FlagUS() {
  return (
    <svg width="18" height="13" viewBox="0 0 24 18" aria-hidden style={{ borderRadius: 2, display: 'block', boxShadow: '0 0 0 1px rgba(0,0,0,0.08)' }}>
      <rect width="24" height="18" fill="#fff" />
      {[0, 2, 4, 6, 8, 10, 12].map((y) => (
        <rect key={y} y={(y / 13) * 18} width="24" height={18 / 13} fill="#B22234" />
      ))}
      <rect width="11" height={(7 / 13) * 18} fill="#3C3B6E" />
    </svg>
  )
}

function FlagCH() {
  return (
    <svg width="13" height="13" viewBox="0 0 16 16" aria-hidden style={{ borderRadius: 2, display: 'block', boxShadow: '0 0 0 1px rgba(0,0,0,0.08)' }}>
      <rect width="16" height="16" fill="#D52B1E" />
      <rect x="6.5" y="3" width="3" height="10" fill="#fff" />
      <rect x="3" y="6.5" width="10" height="3" fill="#fff" />
    </svg>
  )
}

const MARKETS = [
  { code: 'US', locale: 'en', Flag: FlagUS },
  { code: 'CH', locale: 'de', Flag: FlagCH },
]

export default function LangSwitcher({ theme = 'dark' }) {
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const current = getLocale(pathname)
  const logical = stripLocale(pathname)
  const dark = theme === 'dark'

  return (
    <div role="group" aria-label="Market" className="flex items-center gap-1.5 font-mono text-[11px] uppercase tracking-[0.08em]">
      {MARKETS.map(({ code, locale, Flag }) => {
        const active = locale === current
        return (
          <button
            key={code}
            type="button"
            onClick={() => navigate(localePath(locale, logical))}
            aria-current={active ? 'true' : undefined}
            title={code === 'US' ? 'United States (English)' : 'Switzerland (Deutsch)'}
            className={`inline-flex min-h-[44px] items-center gap-1.5 px-1.5 transition-opacity duration-300 ease-quint ${
              active ? 'opacity-100' : 'opacity-50 hover:opacity-100'
            } ${dark ? 'text-cream' : 'text-ink'}`}
          >
            <Flag />
            <span>{code}</span>
          </button>
        )
      })}
    </div>
  )
}
